import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class LocalizationService {
  public langSubject: ReplaySubject<string> = new ReplaySubject<string>();
}
